import axios from '@/api/requests/axios'

export default {
  getAll: () => axios.get('/api/admin/v1/roles'),
  getPermissions: id => axios.get(`/api/admin/v1/roles/${id}`),
  updatePermissions: permissions => axios.put('/api/admin/v1/roles', permissions),
  create: role => axios.post('/api/admin/v1/roles', role),
  remove: id => axios.delete(`/api/admin/v1/roles/${id}`),
}
